module.exports = __webpack_public_path__ + "static/media/learning-8.15c93d36.png";